// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__15uJI","selected":"Chip_selected__3ELNu"};